import React, { PureComponent } from 'react';
import axios from 'axios';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faStar,
  faGlobeAmericas,
  faQuestionCircle,
} from '@fortawesome/free-solid-svg-icons';

import FundHighlights from '../FundHighlights/FundHighlights.js';
import './App.css';

// Import an example fund
// import exampleFunds from '../../examplefund.json';

// Set up Font Awesome
library.add(faStar, faGlobeAmericas, faQuestionCircle);

class App extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      data: null,
    };
  }

  componentDidMount() {
    this.getFundData(this.props.params);
  }

  render() {

    const {
      params,
    } = this.props;

    const {
      data,
    } = this.state;

    return (
      <div className="app">

        {/* If wanted, a blue frame can be added around the highlight */}
        {params.showHighlightCard ?
          <div className='blue-frame'>
            <div className='blue-frame-header'>
              <div className='blue-frame-big-text'>{params.frameBigText}</div>
              <div className='blue-frame-title'>
                {params.frameTitle}
              </div>
              <div className='blue-frame-text'>
                {params.frameText}
              </div>
              <div className='blue-frame-link'>
                <a href={params.frameLink} target={params.frameLink.endsWith('.pdf') ? '_blank' : '_self'}>{params.frameLinkText}</a>
              </div>
              {params.frameLink2 && params.frameLinkText2 &&
                <div className='blue-frame-link'>
                  <a href={params.frameLink2} target={params.frameLink2.endsWith('.pdf') ? '_blank' : '_self'}>{params.frameLinkText2}</a>
                </div>
              }
            </div>

            <div className='blue-frame-body'>
              <FundHighlights
                data={data}
                params={params}
              />
            </div>
          </div>

          : <FundHighlights
            data={data}
            params={params}
          />}

      </div>
    );
  }

  /// Get the Fund Data for the app
  async getFundData(params) {

    const request = {
      method: 'GET',
      url: `${params.dataspanApiUrl}/fundhighlights/data/`,
      params: {
        tickers: params.tickers,
      },
    };

    try {

      // Get the fund data from dataspan
      const response = await axios(request);

      // Save the data to state
      this.setState({ data: response.data });

    } catch (e) {
      console.log(e);
    }

  }

}

export default (App);
